<template>
    <ConfigSection :title="$t('phu_production.configuration.equipment')" :count="groups.length">
        <div class="equipment-selects">
            <article v-for="group in groups" :key="group.key" class="equipment-select">
                <label class="equipment-select__field">
                    <span class="equipment-select__name">{{ group.name }}</span>
                    <span class="equipment-select__control">
                        <select class="equipment-select__input" :value="group.count" @change="onChange(group.key, $event)">
                            <option v-for="choice in choices(group)" :key="choice" :value="choice">{{ choice }}</option>
                        </select>
                        <i class="i-andy-chevron-input-down i-andy-m equipment-select__chevron" aria-hidden="true"></i>
                    </span>
                </label>
            </article>
        </div>
    </ConfigSection>
</template>

<script>
import ConfigSection from './ConfigSection.vue'

export default {
    name: 'EquipmentSection',
    components: { ConfigSection },
    props: {
        groups: { type: Array, required: true }
    },
    methods: {
        choices(group) {
            const values = []
            for (let count = 0; count <= group.max; count += 1) {
                if (count !== 0 && count < group.min && count !== group.count) {
                    continue
                }
                values.push(count)
            }
            return values
        },
        onChange(key, event) {
            this.$emit('change-count', { key, count: Number(event.target.value) })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.equipment-selects {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
}

.equipment-select {
    min-width: 0;
    padding: 8px;
    border: 1px solid $neutro-dark;
    border-radius: $phu-radius-s;
    background-color: $phu-surface;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.06);

    &__field {
        @include display-flex();
        @include align-items(center);
        gap: 16px;
    }

    &__name {
        flex: 1;
        font-family: $text-bold;
        font-size: 1rem;
        line-height: 20px;
        text-transform: uppercase;
        color: $phu-text;
    }

    &__control {
        position: relative;
        flex-shrink: 0;
    }

    &__input {
        width: 72px;
        height: 40px;
        padding: 8px 32px 8px 12px;
        border: 1px solid $neutro-dark;
        border-radius: $phu-radius-s;
        background-color: $phu-surface;
        font-family: $text;
        font-size: 1rem;
        line-height: 18px;
        color: $phu-text;
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
    }

    &__chevron {
        position: absolute;
        top: 8px;
        right: 8px;
        color: $neutro-s50;
        pointer-events: none;
    }
}
</style>
